export default {
  vipUpgrade: {
    title: '축하합니다!!',
    message: 'VIP{from}에서 VIP{to}(으)로 승급되었습니다',
    subtitle: '성원에 감사드립니다. 새로운 레벨에서\n전용 서비스와 특별 혜택을 누리세요.',
    ok: 'OK'
  },
  settle: {
    loading: "Settling...",
    cannotEnterGame: "Your balance is being settled, please try again later.",
    blockedTitle: "Settling In Progress",
    blockedMsg: "Your balance is still being settled. Please wait a moment and try again."
  }
};
